import cn from 'classnames';
import { DownloadCircle } from '#assets/ReactSvg.ts';
import type { Host } from '#dn-types/host.ts';
import { InlineIconLink } from '#screens/hosts/hosts-table/InlineIconLink.tsx';
import { computeHostStatus } from '#util/hostStatus.ts';

type Props = {
  host: Pick<Host, 'createdAt' | 'isBlocked' | 'id'> & {
    metadata: Pick<Host['metadata'], 'version' | 'platform' | 'lastSeenAt' | 'updateAvailable'>;
  };
  dataUpdatedAt: Date;
  className?: string;
};

export function ClientVersion({ host, dataUpdatedAt, className }: Props) {
  const {
    metadata: { version },
  } = host;

  if (!version) {
    const status = computeHostStatus(host, dataUpdatedAt);

    switch (status) {
      case 'unenrolled':
        return 'Not enrolled';
      case 'blocked':
      case 'unknown':
      case 'online':
      case 'inactive':
        return 'Unknown';
    }
  }

  const versionWithV = `v${version}`;
  if (host.metadata.updateAvailable) {
    return (
      <div className={cn(className, 'flex align-center')}>
        {versionWithV}{' '}
        <InlineIconLink title="Download update" to="/downloads">
          <DownloadCircle />
        </InlineIconLink>
      </div>
    );
  }
  return <>{versionWithV}</>;
}
